import React from 'react'

const IconHeartStrokeContactBlock = ({
  className
}: {
  className: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
    >
      <path
        d="M13.5865 25.0662L14 25.3394L14.4135 25.0662C20.3001 21.1765 23.743 17.453 25.4355 14.1141C27.1374 10.7565 27.0697 7.77423 25.9022 5.4942C23.7232 1.23872 17.7813 -0.301476 14 2.88746C10.2187 -0.301476 4.27685 1.23872 2.09782 5.4942C0.930327 7.77423 0.862629 10.7565 2.56453 14.1141C4.25698 17.453 7.69994 21.1765 13.5865 25.0662Z"
        stroke="#162941"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default IconHeartStrokeContactBlock
